import {DiscountLevelFilter} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownDiscountLevel} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useDiscountFilterSection} from '../../shared/useDiscountFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: DiscountLevelFilter;
  resetFilters: (slugs: Array<string>) => void;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    singleSelectOnly?: boolean;
  }) => void;
  onOpen: (filterSlug: string, label: FilterLabels) => void;
  onClose: (filterSlug: string, label: FilterLabels) => void;
  filterLabel: FilterLabels;
};

export const FilterSectionDiscount: FC<Props> = ({
  activeFilters,
  data,
  resetFilters,
  setFilter,
  onOpen,
  onClose,
  filterLabel,
}) => {
  const {
    discountLevelFilterLabel,
    discountLevelFilterSlug,
    activeDiscountFilterValue,
    discountLevelOptions,
    handleApplyDiscount,
    hasAppliedDiscount,
  } = useDiscountFilterSection({
    data,
    activeFilters,
    setFilter,
  });

  if (!discountLevelFilterLabel || !discountLevelFilterSlug) return null;

  const slugsToReset = [discountLevelFilterSlug];

  return (
    <FilterDropdownDiscountLevel
      activeOptionId={activeDiscountFilterValue}
      hasAppliedDiscount={hasAppliedDiscount}
      label={discountLevelFilterLabel}
      onFilterReset={() => resetFilters(slugsToReset)}
      onSelect={handleApplyDiscount}
      options={discountLevelOptions}
      onOpen={() => onOpen(discountLevelFilterSlug, filterLabel)}
      onClose={() => onClose(discountLevelFilterSlug, filterLabel)}
    />
  );
};
